// extracted by mini-css-extract-plugin
module.exports = {"footer":"_10ec90"};